var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveDownMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Send_down_icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M10.874 19.877V4.123a1.125 1.125 0 012.251 0v15.754a1.125 1.125 0 11-2.251 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 5",
    d: "M7.06 16.046a1.125 1.125 0 011.923-.794L12 18.282l3.017-3.03a1.125 1.125 0 011.595 1.588l-3.815 3.831a1.125 1.125 0 01-1.595 0L7.388 16.84a1.122 1.122 0 01-.328-.794z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15112",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgMoveDownMobile;